// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let DialogV5 = require("../common/Components/DialogV5.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let PaymentCardLogo = require("../common/Components/PaymentCardLogo.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SetAccountCardDialog = require("./SetAccountCardDialog.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PaymentCardMaskedNumber = require("../common/Components/PaymentCardMaskedNumber.bs.js");
let BillingSettingsPagePaymentCard_accountV5_graphql = require("../../__generated__/BillingSettingsPagePaymentCard_accountV5_graphql.bs.js");
let BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql = require("../../__generated__/BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.bs.js");

let convertFragment = BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, fRef);
}

let CardFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let amex = (require('../../../assets/images/amex.svg'));

let discover = (require('../../../assets/images/discover.svg'));

let mastercard = (require('../../../assets/images/mastercard.svg'));

let visa = (require('../../../assets/images/visa.svg'));

let Logos = {
  amex: amex,
  discover: discover,
  mastercard: mastercard,
  visa: visa
};

function BillingSettingsPagePaymentCard$CardDetails(props) {
  let card = RescriptRelay_Fragment.useFragment(BillingSettingsPagePaymentCard_CardDetails_accountCard_graphql.node, convertFragment, props.card);
  let expiresDate = (
    card.expMonth < 10 ? "0" : ""
  ) + card.expMonth.toString() + "/" + card.expYear.toString();
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(DialogV5.make, {
        title: "Update Payment Card",
        isOpen: match[0],
        ariaLabel: "Update Payment Card",
        onDismiss: () => setIsOpen(param => false),
        size: "Small",
        children: JsxRuntime.jsx(SetAccountCardDialog.make, {
          closeDialog: () => setIsOpen(param => false)
        })
      }),
      JsxRuntime.jsx(PaymentCardLogo.make, {
        card: card.fragmentRefs,
        className: "w-14 lg:w-16 flex-shrink-0 overflow-hidden"
      }),
      JsxRuntime.jsx(PaymentCardMaskedNumber.make, {
        card: card.fragmentRefs,
        className: "lg:ml-4 mt-8 lg:mt-0 flex-shrink-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("span", {
            children: "Expires ",
            className: "text-gray-500"
          }),
          expiresDate
        ],
        className: "lg:ml-10 mt-8 lg:mt-0 flex-shrink-0"
      }),
      JsxRuntime.jsx("div", {
        children: Stdlib_Option.getOr(card.name, ""),
        className: "lg:ml-10 mt-8 lg:mt-0 flex-shrink-0"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          onClick: param => setIsOpen(param => true),
          size: "small",
          children: "Edit Card"
        }),
        className: "flex-grow flex justify-end lg:pl-5 mt-8 lg:mt-0"
      })
    ],
    className: "p-4 lg:py-5 lg:px-4 border border-gray-300 flex flex-col lg:flex-row items-center text-gray-700"
  });
}

let CardDetails = {
  CardFragment: CardFragment,
  Logos: Logos,
  make: BillingSettingsPagePaymentCard$CardDetails
};

function BillingSettingsPagePaymentCard$AddCard(props) {
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(DialogV5.make, {
        title: "Add Payment Card",
        isOpen: match[0],
        ariaLabel: "Add Payment Card",
        onDismiss: () => setIsOpen(param => false),
        size: "Small",
        children: JsxRuntime.jsx(SetAccountCardDialog.make, {
          closeDialog: () => setIsOpen(param => false),
          hasExistingCard: false
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          "You haven't registered a credit card",
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => setIsOpen(param => true),
              size: "small",
              children: "Add a Credit Card"
            })
          })
        ],
        className: "flex flex-col gap-4"
      })
    ]
  });
}

let AddCard = {
  make: BillingSettingsPagePaymentCard$AddCard
};

let convertFragment$1 = BillingSettingsPagePaymentCard_accountV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, fRef);
}

let AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function BillingSettingsPagePaymentCard(props) {
  let match = RescriptRelay_Fragment.useFragment(BillingSettingsPagePaymentCard_accountV5_graphql.node, convertFragment$1, props.account);
  let card = match.card;
  if (card !== undefined) {
    return JsxRuntime.jsx(BillingSettingsPagePaymentCard$CardDetails, {
      card: card.fragmentRefs
    });
  } else {
    return JsxRuntime.jsx(BillingSettingsPagePaymentCard$AddCard, {});
  }
}

let View;

let SecondaryButton;

let LinkButton;

let ContentBox;

let PageTitle;

let SubTitle;

let PaymentForm;

let Heading;

let make = BillingSettingsPagePaymentCard;

exports.View = View;
exports.SecondaryButton = SecondaryButton;
exports.LinkButton = LinkButton;
exports.ContentBox = ContentBox;
exports.PageTitle = PageTitle;
exports.SubTitle = SubTitle;
exports.PaymentForm = PaymentForm;
exports.Heading = Heading;
exports.CardDetails = CardDetails;
exports.AddCard = AddCard;
exports.AccountFragment = AccountFragment;
exports.make = make;
/* amex Not a pure module */
